<template>
    <div class="container">

        <div class="row mb-4">
          <div class="col">
            <h2 class="text-center">ESTER: A Machine Reading Comprehension Dataset for</h2>
            <h2 class="text-center">Event Semantic Relation Reasoning</h2>
          </div>
        </div>


      <nav>
        <div class="nav nav-pills nav-fill" id="nav-tab" role="tablist">
          <a class="nav-item nav-link"
             v-on:click="switch_tab('overview')"
             v-bind:class="{
              'active': active_tab === 'overview'
             }"
          >Overview</a>

          <!-- <a class="nav-item nav-link"
             v-on:click="switch_tab('step-by-step')"
             v-bind:class="{
              'active': active_tab === 'step-by-step'
             }"
          >Leaderboard</a> -->

          <a class="nav-item nav-link"
             v-on:click="switch_tab('payment')"
             v-bind:class="{
              'active': active_tab === 'payment'
             }"
          >Leaderboard</a>

          <!-- <a class="nav-item nav-link"
             v-on:click="switch_tab('working')"
             v-bind:class="{
              'active': active_tab === 'working'
             }"
          >Working Area</a> -->
        </div>
      </nav>

      <div v-if="active_tab === 'overview'">
        <overview></overview>
        <div class="row">
          <div class="col-8"></div>
          <div class="col-4">
            <!-- <button
                    type="button"
                    class="btn btn-info btn-lg"
                    v-on:click="switch_tab('step-by-step'); focus_nav_tab();"
            >Read the step-by-step instructions</button> -->
          </div>
        </div>
      </div>

      <div v-if="active_tab === 'step-by-step'">
        <step-by-step v-bind:max_bonus="max_bonus" v-bind:bonus_per_question="bonus_per_question"></step-by-step>
        <div class="row">
          <div class="col-8"></div>
          <div class="col-4">
            <!-- <button
                    type="button"
                    class="btn btn-info btn-lg"
                    v-on:click="switch_tab('payment'); focus_nav_tab();"
            >Learn how we pay bonus.</button> -->
          </div>
        </div>
      </div>

      <div v-if="active_tab === 'payment'">
        <payment v-bind:max_bonus="max_bonus" v-bind:bonus_per_question="bonus_per_question"></payment>
        <div class="row">
          <div class="col-8"></div>
          <div class="col-4">
            <!-- <button
                    type="button"
                    class="btn btn-info btn-lg"
                    v-on:click="switch_tab('working'); focus_nav_tab();"
            >Start working now!</button> -->
          </div>
        </div>
      </div>


      <div v-if="show_tab_working">
        <div class="card mb-4">

          <!--Title infos-->
          <div class="card-header">
            <h2>Your working area</h2>
          </div>

          <!---->
          <div class="card-body">
            <div class="container">
              <div class="row">
                <div class="card-body">
                  <div class="card-text">
                    <span style='color:Tomato; font-family: serif;'>[WARNING] </span><span style='font-family: serif;'><strong>Refreshing this page will randomly reload *new* passages and you will also *lose* all your answers, 
                      but switching tabs or using the passage navigation buttons won't delete anything.</strong></span>
                  </div>
                  <div class="card-text">
                    <span style='color:DodgerBlue; font-family: serif;'>[TIP 1] </span><span style='font-family: serif;'><strong>We put reminders as tooltips for many of the buttons below. 
                      Move your mouse above the question marks beside these buttons to see (if a pop-up instruction doesn't disappear, just click on any empty space).</strong></span>
                  </div>
                  <div class="card-text">
                    <span style='color:DodgerBlue; font-family: serif;'>[TIP 2] </span><span style='font-family: serif;'><strong> You can always click on the <mark>"Overview"</mark> and the <mark>"Step-by-step Instructions"</mark> tabs above 
                    to remind yourself how to judge the validity of a significant event, a question, or an answer.
                      Again, you won't lose your annotations by doing so.</strong></span>
                  </div>
                <!--  It's highly recommended that you open that task <a target="_blank" href="https://qatmr-qualification.github.io/">here</a> in a new window and use it as a reference when you're not sure about certain rules.-->
                </div>
              </div>

              <div class="card mb-2">
                  <div class="card-header">
                      <h4>&#9888; <span style="color: red"><strong>Common Mistakes</strong></span>️</h4>
                  </div>
                  <div class="card-body">
                      Please avoid making the following mistakes. <br/>
                      <ol>
                          <li><span style="color: red"><strong> [Coreference] Don't ask questions about event arguments. </strong></span>Remember
                              that we define event arguments as an event action's subject,
                              object, time and locations. For [Coreference] relation, events in the question and answer must share the same arguments. 
                              However, some participants mistakenly think that event A's arguments form a [Coreference] relation with A. 
                              For example, "participate in planning": "participate" does not corefer to "planning" as "planning" is effectively the object of "participate;" or "hope for a change": "hope" does not corefer to "change." 
                          </li>

                          <li><span style="color: red"><strong> [Sub-event] Questions do not include any complex and concrete event. </strong></span>
                              <br/></li>

                              Sub-event questions <strong>must have</strong> a complex event that contains a group of sub-events. The complex event itself <strong>must be concrete</strong> even if it's imaginary. Words such as "happen", "happened", "action", "incident", etc. are too broad and hence, are not concrete action words.

                          <li><span style="color: red"><strong> Answers are not complete.</strong></span>
                              There could be multiple valid answers in the passage. Please select all answers that apply to your questions. Pay special attention to answers that locate far away from the core events in your questions. 
                          </li>

                      </ol>

                      <br>
                  </div>
              </div>
                <div class="card">
                      <div class="card-header"
                           v-bind:class="{
                            'bg-danger': !questions_created_satisfied || !questions_warmup_satisfied,
                            'bg-warning': questions_created_satisfied && questions_warmup_satisfied && !questions_modified_satisfied,
                            'bg-success': questions_created_satisfied && questions_modified_satisfied && questions_warmup_satisfied,
                          }"
                      >
                        <strong>Overall Progress on All Passages</strong>
                      </div>

                      <ul class="list-group list-group-flush">
                        <li class="list-group-item"
                            v-bind:class="{
                            'list-group-item-danger': !questions_created_satisfied,
                            'list-group-item-success': questions_created_satisfied,
                          }"
                        >
                          Total questions created [required]: <span style="float: right">{{current.question_created}} / {{this.required_question_count}}</span>
                        </li>
                        <li class="list-group-item"
                            v-bind:class="{
                            'list-group-item-danger': !questions_warmup_satisfied,
                            'list-group-item-success': questions_warmup_satisfied,
                          }"
                        >
                          Pay: <span style="float: right">${{pay_base_amount | currency}} + $ {{ pay_bonus_amount | currency}} = $ {{ pay_total_amount | currency}}</span>
                        </li>

                      </ul>
                </div>

              <div class="card-body">
              </div>

              <div class="row">
                <!--Left panel for showing passages with highlighted events-->
                <div class="col-lg-6" style="z-index: 0">
                  <div class="card sticky-top">
                    <div class="card-header">
                      <h4
                              style="text-align: center"
                      >
                        <button
                                type="button"
                                class="btn btn-secondary"
                                style="float: left"
                                v-on:click="previous_passage"
                                data-balloon-pos="up"
                                data-balloon-length="large"
                                aria-label="You can move back and forth without losing your annotations. However, do not refresh this page using the refresh button of your browser."
                        ><i class="fas fa-chevron-left"></i></button>
                        <span
                                style="margin:0 auto; display: inline-block"
                        >
                          Passage: {{staging.passage_id + 1}} / {{number_of_passages}}
                      </span>

                        <button
                                type="button"
                                class="btn btn-secondary"
                                style="float: right"
                                v-on:click="next_passage"
                                data-balloon-pos="up"
                                data-balloon-length="large"
                                aria-label="You don't need to use all passages if you can get enough good questions from some of them. If you do use more than one passage, please ask a similar number of questions per passage."
                        ><i class="fas fa-chevron-right"></i></button>
                      </h4>
                    </div>
                    <div class="card" v-if="staging.showing_qa_panel
                    && staging.current_question.text!==null
                    && staging.current_question.text!==undefined
                    && staging.current_question.text!==''">
                      <div class="card-body">
                        <p>
                          <strong>
                          <span style='color:DodgerBlue;'>[Question] {{staging.current_question.text}}</span>
                          </strong>
                        </p>
                      </div>
                    </div>
                    <div class="card-body passage-display-box">
                      <div class="card-text" v-if="data_loaded">
                        <div>
                          <div class="passage-text" 
                          v-on:mouseleave="invalidate_selection"
                          v-on:mousemove ="turn_on_event_highlight"
                          >
                          <span
                                  v-for="(char, index) in staging.passage"
                                  v-bind:key="char.index"
                                  v-on:mousedown="mousedown_text(index)"
                                  v-on:mouseup="mouseup_text(index)"
                                  v-on:mouseenter="mouseenter_text(index)"
                                  v-on:dblclick="double_clicked_text(index)"
                                  class="noselect"
                                  v-bind:class="{
                                    highlight: should_highlight(index),
                                    select_highlight: is_in_selection_highlight(index),
                                    is_selected_answer: is_selected_answer_highlight(index),
                                    action_highlight: is_selected_action_highlight(index),
                                  }"
                          >{{char}}</span>
                          </div>
                          <!--  Make sure there is NO space between the actual data and the span tag. Otherwise it will mess up the display format.-->
                          <div class="spinner-border" role="status" v-if="!data_loaded">
                            <span class="sr-only"></span>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <div class="card">
                      <!--Submit button-->
                      <br>
                      <div class="row mb-4">
                        <div class="col text-center">
                          <button
                                  id="ready_submit"
                                  type="button"
                                  class="btn btn-primary"
                                  v-bind:class="{
                                  'btn-dark': !should_submit_enable,
                                  'btn-warning': should_submit_enable && !questions_modified_satisfied,
                                  'btn-success': should_submit_enable
                                }"
                                  v-on:click="check_before_submit"
                                  :disabled="!should_submit_enable">
                            {{submit_button_text}}
                            <span
                                    class="button-question-tooltip"
                                    data-balloon-pos="down"
                                    data-balloon-length="large"
                                    aria-label="When this button is yellow, you can still submit, but it's not suggested if you do this very often."
                            > ? </span>
                          </button>
                        </div>
                      </div>
                      <div class="alert alert-danger fade show" role="alert" v-if="has_submission_error">
                        <strong>{{submission_error_msg}}</strong>
                      </div>

                      <div class="row mb-4">
                        <div class="col text-center">
                          <button
                                  type="button"
                                  class="btn btn-info btn-sm"
                                  v-on:click="focus_feedback">
                            Give Us Feedback
                            <span
                                  class="button-question-tooltip"
                                  data-balloon-pos="down"
                                  data-balloon-length="large"
                                  aria-label="Type in the box below."
                            > ? </span>
                          </button>
                        </div>
                      </div>

                      <div class="row justify-content-center">
                        <form
                                name='mturk_form'
                                method='post'
                                id='mturk-external-submit-form'
                                v-bind:action="mturk_params.turkSubmitTo"
                                v-bind:class="{hidden: submission_not_ready}"
                        >
                          <input type='hidden' name='assignmentId' id='assignmentId' v-bind:value="mturk_params.assignmentId"/>
                          <input id="generated_answers" name="generated_answers" type="hidden" v-model="generated_answers">
                          <input id="generated_answers_event" name="generated_answers_event" type="hidden" v-model="generated_answers_event">
                          <!--<input type='submit' class="btn btn-success btn-sm" id='submitButton' name="submitButton" value='Click here to submit HIT'>-->
                        </form>
                      </div>
                    </div>
                  </div>

                </div>

                <!--Right panel for Event Selection-->
                <div class="col-lg-6">
                  <div class="card mb-2">
                    <div class="card-header">
                        <h4> <span style='color: blue;'> Event Action Selection </span> </h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h6> Double-Clicking or dragging on an Event Action to Start</h6>
                          <div v-if="!this.staging.showing_qa_panel">
                            <small> We provide some highlighted event action examples, but you can choose other event actions if they help.
                            We want significant events that satisfy event arguments. Click on "Overview" above if you forget.</small>
                            <div class="input-group mb-3">
                            <input
                                    type="text"
                                    class="form-control"
                                    v-bind:value="display_selected_text"
                                    placeholder="Event action not selected"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2" disabled
                            
                            >
                            <!--
                            <div class="input-group-append">
                            <select name="event-span-type" 
                                  class="form-control" 
                                  v-model="staging.current_action.span">
                              <option value="" selected disabled hidden> 
                                Select an Event Span
                              </option>
                              <option value="Second"> Second </option>
                              <option value="Minute"> Minute </option>
                              <option value="Hour"> Hour </option>
                              <option value="Day"> Day </option>
                              <option value="Week"> Week </option>
                              <option value="Month"> Month </option>
                              <option value="Year"> Year </option>
                          </select>
                          </div>
                          :disabled="staging.current_action.span === ''"
                          -->
                          </div>
                        <div class="alert alert-danger fade show" role="alert" v-if="has_event_error">
                          <strong>{{event_selection_error_message}}</strong>
                        </div>
                        <div class="input-group mb-3">
                              <button
                                      class="btn btn-primary"
                                      type="button"
                                      v-on:click="add_action"
                                      >Select Action
                                <span
                                        class="button-question-tooltip"
                                        data-balloon-pos="down"
                                        data-balloon-length="large"
                                        aria-label="Click to highlight your selected answer in text."
                                > ?
                                </span>
                              </button>
                        </div>
                        </div>
                        </div>
                      </div>

                      <!--  v-bind:event_span="get_event_span(e)" --> 
                      <div class="row mt-4">
                        <div class="col">
                          <action-card
                              v-for="(e, idx) in sorted_event_actions"
                              v-bind:key="idx"
                              v-bind:event="e"
                              v-bind:is_editing="is_editing_action(e)"
                              v-bind:is_selecting="is_selecting_event(e)"
                              @edit="edit_action(e)"
                              @delete="delete_action(e)"
                          ></action-card>
                        <br>
                        <div class="input-group mb-3">
                        <button
                            class="btn btn-primary"
                            type="button"
                            v-on:click="switch_stage"
                            :disabled="this.current.action_created==0"> {{this.finish_event_selection_text}}
                            <span
                                class="button-question-tooltip"
                                data-balloon-pos="down"
                                data-balloon-length="large"
                                aria-label="Click to finish event selection."
                            > ?
                            </span>
                          </button>
                        </div>
                        </div>
                        </div>
                    </div>  
                    </div>

                    <br>
                    <!--Right panel for Event QA Template-->
                    <div class="card mb-2">
                    <div class="card-header">
                        <h4> <span style='color: blue;'> Event Relation QA  </span></h4>
                    </div>
                    <div class="card-body">
                      <div>
                        <h6>*All* questions and answers must include event actions. Click on "Overview" tab above if you forget relation question types.</h6>
                      </div>
                      <!--
                      <div class="row">
                        <div class="col">
                      -->
                      <div class="alert alert-danger fade show" role="alert" v-if="has_qa_error">
                        <strong>{{qa_error_message}}</strong>
                      </div>
                      
                      <div class="row mt-4" v-if="staging.showing_qa_panel">
                        <div class="col">
                          <input
                                id="question-input"
                                class="form-control"
                                name="input-question"
                                placeholder="Write an event relation question here!"
                                v-model="staging.current_question.text"
                                v-on:input="on_question_text_change"
                                :disabled="staging.current_question.is_default_question"
                          >

                         <div class="input-group mb3">
                            <select name="question-type" 
                                  class="form-control" 
                                  v-model="staging.current_question.type">
                              <option value="" selected disabled hidden> 
                                Select a Question Type
                              </option>
                              <option value="Counterfactual Conditional"> Counterfactual Conditional</option>
                              <option value="Sub-event"> Sub-event </option>
                              <option value="Coreference"> Coreference </option>
                          </select>
                          </div>

                         <div class="input-group mb3" v-if="staging.current_question.type === 'Sub-event'">
                            <select name="subevent-question" 
                                  class="form-control" 
                                  v-model="staging.current_question.include_event">
                              <option value="" selected disabled hidden> 
                                Question contains a complex and concrete event?
                              </option>
                              <option value="yes"> yes </option>
                              <option value="no"> no </option>
                          </select>
                          </div>
                          <br>
                          <div>
                           <small>  To select answers, drag your mouse over the text span. Be careful when you are hitting the right edge of the text box. </small>
                          </div>
                          <div class="input-group mb-3">
                            <input
                                    type="text"
                                    class="form-control"
                                    v-bind:value="display_selected_text"
                                    placeholder="Answer not selected"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2" disabled>
                            <div class="input-group-append">
                              <button
                                      class="btn btn-primary"
                                      type="button"
                                      v-on:click="add_answer"
                                      :disabled="is_selection_empty"> Add Answer
                                <span
                                        class="button-question-tooltip"
                                        data-balloon-pos="down"
                                        data-balloon-length="large"
                                        aria-label="Click to highlight your selected answer in text."
                                > ?
                                </span>
                              </button>
                            </div>

                            <div class="input-group-append">
                              <button
                                      class="btn btn-outline-danger"
                                      type="button"
                                      v-on:click="clear_selection(false)"
                                      data-balloon-pos="up"
                                      aria-label="Clear selection"
                              ><i class="fas fa-times"></i></button>
                            </div>
                          </div>
                          <button
                                  type="button"
                                  class="btn btn-primary mt-4"
                                  v-on:click="add_or_save_question">
                            <i class="fas fa-save"></i> {{save_question_button_text}}
                            <span
                                    class="button-question-tooltip"
                                    data-balloon-pos="right"
                                    data-balloon-length="large"
                                    aria-label="Click here to add your input in the above two boxes (i.e., question and answers). We will validate your answers manually. We reserve the right to reject hits from spammers."
                            > ?
                            </span>
                          </button>

                          <event-card class=""
                                      v-for="(event, idx) in sorted_staging_answers"
                                      v-bind:key="idx"
                                      v-bind:value="event_text(event)"
                                      @delete="delete_answer(event)"
                          >
                          </event-card>
                        </div>
                      </div>

                      <question-card
                              v-for="(q, idx) in sorted_questions"
                              v-bind:key="idx"
                              v-bind:question="q"
                              v-bind:answer_text="get_all_answer_surface_form(q)"
                              v-bind:is_editing="is_editing(q)"
                              v-bind:show_qa="is_showing_qa_panel(q)"
                              @delete="delete_question(q)"
                              @edit="edit_question(q)"
                              @derive="derive_question(q)"
                              @pin="pin_to_top(q)"
                              @up="move_up(q)"
                              @down="move_down(q)"
                      ></question-card>
                    
                    </div>
                    <!--
                  </div>
                  -->
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" >
          <div class="col" style="z-index: -1">
            <div class="card mb-4">
              <div class="card-header">
                <h3>
                  Please leave your feedback here
                </h3>
              </div>
              <div class="card-body">
                <div id="comment">
                <textarea
                        id="feedback-form"
                        rows="15"
                        class="form-control"
                        placeholder="Please leave your feedback here."
                        v-model="feedback">
                </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    </div>
</template>

<script>
import _ from "lodash"
import DataHandler from "./data_handler.js"
import QuestionCard from "./components/QuestionCard"
import EventCard from "./components/EventCard"
import ActionCard from "./components/ActionCard"
import Payment from "./components/Payment"
import Overview from "./components/Overview"
import StepByStep from "./components/StepByStep"

import Vue from 'vue'
import queryString from "query-string";

const question_keywords = [];
const default_questions = [];
const bad_question_keywords = [];

const number_of_passages = 3;
const required_question_count = 3;

export default {
  name: 'AnnotationInterface',
  components: {
    'question-card': QuestionCard,
    'event-card': EventCard,
    'action-card': ActionCard,
    'payment': Payment,
    'overview': Overview,
    'step-by-step': StepByStep,
  },
  data: function(){
    return {

      /**
       *
       * Tab switching.
       *
       */
      active_tab: "overview",
      frozen: true,
      frozen_time: 3,
      seconds_remain: 60,

      required_question_count: required_question_count,
      number_of_passages: number_of_passages,
      max_bonus: 5.0,
      pay_base_amount: 5.0,
      bonus_per_question: 0.5,

      finish_event_selection_text: "Finish Event Selection",
      data_loaded: false, // Oneway flag.

      //We have methods that modify this data in an unwatched way, so HTML rendering should no reply
      // on anything from this object. Use render use staging object instead.
      annotations: {},

      /**
       * {
       *     passage_id: {
       *         events: [(0, 10), (56, 62)],
       *         questions: {
       *             qid: {
       *                    question_id,
       *                    isDefaultQuestion: true,
       *                    isAnswered: true,
       *                    answer: [(0, 10)],
       *                    text: []
       *                  }
       *         }
       *     }
       * }
       */

      // Current data displayed on interface.
      current: {
        selection_state: "none",
        selection: {
          start: -1,
          end: -1,
          current: -1,
        },

        selected_char_indices: {

        },


        selected_char_indices_for_answers: {

        },

        selected_char_indices_for_action: {

        },

        // Should never decrease.
        question_id_counter : 0,

        action_id_counter : 0,

        // faithful counter of how many question created. aka. should decrease when deleted.
        question_created: 0,

        action_created: 0,

        question_modified: 0,

        // faithful counter of how many default question has been answered.
        default_question_count: 0,

        // How many default questions is created.
        default_question_answered_count: 0,
      },
/**
*      Staging data for current passage.
*/
      // Staged annotations.
      staging: {
        pinned_question_id: null,
        showing_qa_panel: true,
        showing_qa_work_area: false,
        passage_id: -1,
        passage: "",

        has_action: false,

        current_action:{
          _position: null,
          action_id: null,
          text: "",
          span: ""
        },

        current_question: {
          _position: null,
          question_id: null,
          text: "",
          type: "",
          is_default_question: false,
          answers:{},
          include_event: "",
          //question_is_derived_from: null,
        },

        events: {},
        actions: {},
        questions: {},
        //   Example questions format.
        //   qid: {
        //      question_id: "",
        //      isDefaultQuestion: true,
        //      isAnswered: true,
        //      answer: [(0, 10)],
        //      text: ""
        //   }
      },

/**
 *      Misc data.
 */
      feedback: "",


      question_order_counter : 0,
      action_order_counter: 0,

/**
 *      Error reporting related data.
 */
      event_selection_error_message : "",
      has_event_error: false,

      qa_error_message : "",
      has_qa_error: false,
      submission_error_msg :"",
      has_submission_error:false,


/**
 *      Submission form control data.
 */
      submission_not_ready: true,
      generated_answers: "",
      generated_answers_event: "",

      mturk_params: {
        assignmentId: "",
        hitId: "",
        turkSubmitTo: "",
        workerId: "",
        isPreview: true,
      }
    };
  },

  mounted: async function(){
    // Parse the current query string.
    // console.log(location.search);
    const parsed_query_string = queryString.parse(location.search);
    // console.log(parsed_query_string);
    // console.log(parsed_query_string);

    const assignmentId = parsed_query_string.assignmentId;

    if (assignmentId === "ASSIGNMENT_ID_NOT_AVAILABLE"){
      console.log("Preview mode.");
      this.mturk_params.isPreview = true;
    }

    const hitId = parsed_query_string.hitId;
    const turkSubmitTo = parsed_query_string.turkSubmitTo;
    const workerId = parsed_query_string.workerId;

    this.mturk_params.turkSubmitTo = turkSubmitTo + "/mturk/externalSubmit";
    this.mturk_params.workerId = workerId;
    this.mturk_params.hitId = hitId;
    this.mturk_params.assignmentId = assignmentId;

    console.log(parsed_query_string.numPassage);
    console.log(parsed_query_string);
    this.pay_base_amount = 'basePay' in parsed_query_string ?  parseFloat(parsed_query_string.basePay): 0.0;
    this.required_question_count = "requiredQuestion" in parsed_query_string ? parseInt(parsed_query_string.requiredQuestion) : 5;
    this.number_of_passages = "numPassage" in parsed_query_string ? parseInt(parsed_query_string.numPassage) : 2;
    this.max_bonus = "maxBonus" in parsed_query_string ? parseFloat(parsed_query_string.maxBonus) : 0.0 ;
    this.bonus_per_question = "bonusPerQuestion" in parsed_query_string ? parseFloat(parsed_query_string.bonusPerQuestion) : 0.0 ;

    const self = this;
    const passages = await DataHandler.fetchPassagesWithRetries(1, this.number_of_passages);
    console.log("fetch-data success!", passages);

    this.number_of_passages = passages.length;

    _.each(passages, (passage, idx) => {
      const real_passage_id = passage.passage_id;
      self.annotations[idx] = {
        passage: passage.passage,
        doc_id: passage.doc_id,
        sent_id: passage.sent_id,
        events: passage.events,
        actions: {},
        questions: {},
        passage_id: real_passage_id,
      };
    });

    this.data_loaded = true;
    this.stage_new_passage(0);

    // timer to release the submit button

    const update_remain_time_timer = setInterval(
            function(){
              self.seconds_remain -= 1;
              if (self.seconds_remain < 0){
                self.frozen = false;
                clearInterval(update_remain_time_timer);
              }
            }, 1000);

    // setTimeout(function(){
    //   }, 1000*60*self.frozen_time);



  },
  computed: {

    sorted_questions: function(){
        const self = this;
        return _.orderBy(this.staging.questions, function(q){
          if (q.question_id === self.staging.pinned_question_id){
            return -99999;
          }
          return q._position;
        });
        // return [];
    },

    sorted_event_actions: function(){
        //const self = this;
        return _.orderBy(this.staging.actions, function(a){
          return a._position;
        });
        //return [];
    },

    sorted_staging_events: function(){
      let ret = _.sortBy(Object.values(this.staging.events), [
        event => {
          return event.start;
        },
        event => {
          return event.end;
        }
      ]);
      return ret;
    },

    sorted_staging_answers: function(){
      let ret = _.sortBy(Object.values(this.staging.current_question.answers), [
      answer => {
      return answer.start;
      },
      answer => {
      return answer.end;
      }
      ]);
      return ret;
    },

    event_selection_button_text: function(){
      if (this.staging.showing_qa_panel){
        return "Edit Event Selection";
      }else{
        return "Finish Selection";
      }
    },

    event_selection_button_tooltip_text: function(){
      if (this.staging.showing_qa_panel){
        return "Click to add/delete your event selections.";
      }else{
        return "Click to highlight your event selections in text and then you can ask questions on the right panel.";
      }
    },

    save_question_button_text: function(){
      if (this.staging.current_question.question_id !== null){
        return "Save Question & Answer(s)";
      }

      //if (this.staging.current_question.question_is_derived_from !== null){
      //  return "Add New Derived Question";
      //}

      return "Add Question & Answer(s)";

    },


    /**
     * If the submit button should be disabled.
     *                               Questions created: <span style="float: right">{{current.question_created}} / {{this.required_question_count}}</span>
     *</li>
     **<li class="list-group-item">
     *    Default questions answered: <span style="float: right">{{current.default_question_answered_count}} / {{current.default_question_count}}</span>
     * @returns {boolean}
     */
    should_submit_enable: function(){
      if(this.frozen){
        return false;
      }
      return this.current.default_question_answered_count >= this.current.default_question_count && this.current.question_created >= this.required_question_count;
    },
  

    /**
     * If the Next passage button is disabled.
     * @returns {boolean}
     */
    next_passage_disabled: function(){
      return false;
    },


    /**
     * If the Previouse passage button is disabled.
     * @returns {boolean}
     */
    prev_passage_disabled: function(){
      return false;
    },

    /**
     * How many questions has the user created.
     * @returns {number}
     */

    pay_bonus_amount: function(){
      let total_bonus = Math.max(0, this.bonus_per_question * (this.current.question_created - this.required_question_count));
      return Math.min(total_bonus, this.max_bonus);
    },

    pay_total_amount: function(){
      return this.pay_bonus_amount + this.pay_base_amount;
    },

    /**
     * Display the current selection, if the current selection is too long, it will only show the first 19 chars.
     */
    display_selected_text: function(){
      if (this.current.selection.start >= 0 && this.current.selection.end >= 0){
        let surface = this.staging.passage.substring(this.current.selection.start, this.current.selection.end+1);
        if (surface.length > 20){
          return surface.substring(0, 19) + " ...";
        }
        return surface;
      }else{
        return "";
      }
    },

    is_selection_empty: function(){
      return (this.current.selection.start === -1) || (this.current.selection.end === -1);
    },

    show_tab_instruction: function(){
      return this.active_tab === "instruction";
    },

    show_tab_working: function(){
      return this.active_tab === "working";
    },

    submit_button_text: function(){
      if(!this.frozen){
        return "Submit Response on All Passages";
      }
      return "Submit (enables in "+this.seconds_remain+" seconds)";
    },

    suggested_modified_question_count: function(){
      return Math.ceil(this.required_question_count/3);
    },

    questions_created_satisfied: function(){
      return this.current.question_created >= this.required_question_count;
    },

    questions_warmup_satisfied: function(){
      return this.current.default_question_answered_count >= this.current.default_question_count;
    },

    questions_modified_satisfied: function () {
      return this.current.question_modified >= this.suggested_modified_question_count;
    }

  },

  methods: {
    switch_tab: function(tab){
      this.active_tab = tab;
    },
    focus_nav_tab: function(){
      document.getElementById('nav-tab').scrollIntoView();
    },
    /**
     *
     * Functions that handles error messages.
     *
     */

    hide_event_error: function(){
      this.has_event_error = false;
    },

    hide_qa_error: function(){
      this.has_qa_error=false;
    },

    hide_submission_error: function(){
      this.has_submission_error=false;
    },

    show_event_error: function(msg){
      this.event_selection_error_message = msg;
      this.has_event_error = true;
    },

    show_qa_error: function(msg){
      this.qa_error_message = msg;
      this.has_qa_error=true;
    },

    show_submission_error: function(msg){
      this.submission_error_msg = msg;
      this.has_submission_error=true;
    },
    /**
     *
     * Highlight related functions
     *
     */

    reset_highlight_map: function(){
      for (let i = 0; i < this.staging.passage.length; i++) {
        Vue.set(this.current.selected_char_indices, i, false);
        Vue.set(this.current.selected_char_indices_for_answers, i, false);
        Vue.set(this.current.selected_char_indices_for_action, i, false);
      }
    },

    /**
     *
     * Functions for handling event selections.
     *
     */
    event_text: function(event){
      return this.staging.passage.substring(event.start, event.end+1);
    },

    is_event_text_single_token: function(action){
      let start = action.start;
      let end = action.end;
      if(this.staging.passage.substring(start, end+1).trim().includes(" ")){
        
        return false;
      }

      return true;
    },

    switch_stage: function(){
      //this.clear_selection();
      const key_list = Object.keys(this.staging.actions);
      if (this.staging.showing_qa_panel){
          this.staging.showing_qa_panel = false;
          for (let i = 0; i < key_list.length; i++) {
            const key = key_list[i];
            this.staging.actions[key].is_selecting = true;
          } 
          this.do_highlight_all_event_selection();
          this.finish_event_selection_text = "Finish Event Selection";
      }
      else{
          this.staging.showing_qa_panel = true;
          for (let i = 0; i < key_list.length; i++) {
            const key = key_list[i];
            this.staging.actions[key].is_selecting = false;
          }
          for(let i = 0; i <= this.staging.passage.length; i++){
            Vue.set(this.current.selected_char_indices, i, false);
          }
          this.finish_event_selection_text = "Edit Event Selection";
      }
      
      const question_key = Object.keys(this.staging.questions);
      for (let i = 0; i < question_key.length; i++) {
        const key = question_key[i];
        this.staging.questions[key].show_qa = this.staging.showing_qa_panel;
      }
    },

    can_add_event: function(){
      let start = this.current.selection.start;
      let end = this.current.selection.end;
      let surface = this.staging.passage.substring(start, end+1).trim();
      if(surface.length === 0){
        this.show_event_error("The is event empty.");
        return false;
      }

      if(!this.is_event_text_single_token()){
        this.show_event_error("The correct event should be a single word");
        return false;
      }

      // By design, we cannot add any duplicated events as answers to the same questinos.
      // So we don't have to check for this case.
      // if(this.is_answer_duplicated()){
      //   this.show_qa_error("This answer is duplicated!");
      //   return false;
      // }

      this.hide_event_error();
      return true;
    },

    can_add_action: function(action){
      let start = action.start;
      let end = action.end;
      let surface = this.staging.passage.substring(start, end+1).trim();
      if(surface.length === 0){
        this.show_event_error("The is event empty!");
        return false;
      }

      if(surface.length === 1){
        this.show_event_error("The correct event action should be a single word!");
        return false;
      }

      if (!this.is_event_text_single_token(action)){
        this.show_event_error("The correct event action should be a single word!");
        return false;
      }

      if(this.is_action_duplicated(action)){
        this.show_event_error("This answer is duplicated!");
         return false;
      }

      this.hide_event_error();
      return true;
    },


    is_action_duplicated: function(answer){
      if (this.staging.current_action.start == answer.start && 
      this.staging.current_action.end == answer.end){
        return false;
      }
      const key_list = Object.keys(this.staging.actions);
      for (let i = 0; i < key_list.length; i++){
        const start = this.staging.actions[key_list[i]].start;
        const end = this.staging.actions[key_list[i]].end;
        for (let j = start; j <= end; j++){
          if (j >= answer.start && j <= answer.end){
            return true
          }
        }
      }
      return false;
    },

    is_answer_duplicated: function(answer){
      const key_list = Object.keys(this.staging.current_question.answers);
      for (let i = 0; i < key_list.length; i++){
        const start = this.staging.current_question.answers[key_list[i]].start;
        const end = this.staging.current_question.answers[key_list[i]].end;
        for (let j = start; j <= end; j++){
          if (j >= answer.start && j <= answer.end){
            return true
          }
        }
      }
      return false;
    },

    is_from_event_list: function(action){
      for(let i = 0; i < this.staging.events.length; i++){
        const start = Number(this.staging.events[i].start);
        const end = Number(this.staging.events[i].end);
        if (action.start == start && action.end == end){
          return true;
        }
      }
      return false;
    }, 

    trim_start_end_to_nearest_space: function(){
      const old_start = this.current.selection.start;
      const old_end = this.current.selection.end;

      if (old_start === -1 || old_end === -1){
        return;
      }

      let new_start = old_start;
      let new_end = old_end;

      for(let i = old_start; i <= old_end; i++){
          if (this.staging.passage.charAt(i) !== " "){
            new_start = i;
            break;
          }
      }

      for(let i = old_end; i >= old_start; i--){
          if (this.staging.passage.charAt(i) !== " "){
            new_end = i;
            break;
          }
      }

      this.current.selection.start = new_start;
      this.current.selection.end = new_end;
    },

    add_event: function(){

      this.trim_start_end_to_nearest_space();

      let start = this.current.selection.start;
      let end = this.current.selection.end;
      let event_key = start + "_" + end;

      const event = {start, end, key: event_key};

      if (!this.can_add_event(event)){
          return false;
      }

      const existing_event_count = Object.keys(this.staging.events).length;
      
      Vue.set(this.staging.events, event_key, event);
      this.current.selection.start = -1;
      this.current.selection.end = -1;
      this.current.selection.current = -1;
      this.current.selection.state = "none";

      const updated_event_count = Object.keys(this.staging.events).length;

      const has_update = updated_event_count > existing_event_count;

      if (has_update) {
        if(updated_event_count === 1){
          this.add_default_questions_to_passage();
        }
      }

      // only add default questions when we have events annotated

      return true;
    },

    add_default_questions_to_passage: function(){
      let passage_id = this.staging.passage_id;
      let default_q0 =  {
        question_id: passage_id + "-question-d0",
        is_default_question: true,
        question_is_derived_from: null,
        is_answered: false,
        answers: {},
        text: "What is the subject of this event?",
        _position: this.get_new_question_order_counter()
      };

      let default_q1 =  {
        question_id: passage_id + "-question-d1",
        is_default_question: true,
        question_is_derived_from: null,
        is_answered: false,
        answers: {},
        text: "What is the object of this event?",
        _position: this.get_new_question_order_counter()
      };

      let default_q2 =  {
        question_id: passage_id + "-question-d2",
        is_default_question: true,
        question_is_derived_from: null,
        is_answered: false,
        answers: {},
        text: "Where did (will) this event happen?",
        _position: this.get_new_question_order_counter()
      };

      let default_q3 =  {
        question_id: passage_id + "-question-d3",
        is_default_question: true,
        question_is_derived_from: null,
        is_answered: false,
        answers: {},
        text: "When did (will) this event happen?",
        _position: this.get_new_question_order_counter()
      };
      Vue.set(this.staging.questions, passage_id + "-question-d0", default_q0);
      Vue.set(this.staging.questions, passage_id + "-question-d1", default_q1);
      Vue.set(this.staging.questions, passage_id + "-question-d2", default_q2);
      Vue.set(this.staging.questions, passage_id + "-question-d3", default_q3);
      this.current.default_question_count += 3;
    },

    delete_event: function(event){
      this.$delete(this.staging.events, event.key);
      if(Object.keys(this.staging.events).length===0){
        this.remove_default_questions_in_passage();
      }
    },

    remove_default_questions_in_passage: function(){
      let passage_id = this.staging.passage_id;
      Vue.delete(this.staging.questions,passage_id + "-question-d0");
      Vue.delete(this.staging.questions,passage_id + "-question-d1");
      Vue.delete(this.staging.questions,passage_id + "-question-d2");
      Vue.delete(this.staging.questions,passage_id + "-question-d3");
      this.current.default_question_count -= 3;
    },

    should_highlight: function(index){
      return this.current.selected_char_indices[index] === true;
    },

    do_highlight_all_event_selection: function(){
      for (const key in this.staging.events){
        const event = this.staging.events[key];
        for(let i = event.start; i <= event.end; i++){
          Vue.set(this.current.selected_char_indices, i, true);
        }
      }
    },

    do_highlight_all_action_selection: function(){
      for (const key in this.staging.actions){
        const action = this.staging.actions[key];
        for(let i = action.start; i <= action.end; i++){
          Vue.set(this.current.selected_char_indices_for_action, i, true);
        }
      }
    },


    event_selection_button_clicked(){

      this.clear_selection();

      if(!this.staging.showing_qa_panel){
        // Currently not showing QA panel.
        // this.add_event();
        this.do_highlight_all_event_selection();
      }else{
        for(let i = 0; i <= this.staging.passage.length; i++){
          Vue.set(this.current.selected_char_indices, i, false);
        }
      }
      this.staging.showing_qa_panel = !this.staging.showing_qa_panel;
    },



    /**
     *
     *
     * Functions for modifying current answers.
     *
     *
     */

    answer_contains_event: function(){
      let start = this.current.selection.start;
      let end = this.current.selection.end;
      const key_list = Object.keys(this.staging.actions);
      for (let i=0; i < key_list.length; i++){
        const key = key_list[i];
        if (start <= this.staging.actions[key].start 
        && this.staging.actions[key].end <= end){
          return true;
        }
      }
      return false;
    },

    can_add_answer: function(event){
      if(event.start === -1 || event.end === -1){
        this.show_qa_error("The answer cannot be empty!");
        return false;
      }

      if (this.staging.current_question.text.length === 0){
        this.show_qa_error("This question is empty");
        return false;
      }

      if(!this.answer_contains_event()){
        this.show_qa_error("Your answer must contain a selected event! If you're sure of your answer, you can modify the highlighted event list by clicking the 'Edit Event Selection' button above!");
        return false;
      }

      if(this.answer_overlaps_question(event)){
        this.show_qa_error("Your question and answer shouldn't contain the same event!");
        return false;
      }
      if(this.is_answer_too_long(event)){
        this.show_qa_error("Your answer MUST NOT exceed 12 words. Consider making your answer consise!")
        return false;
      }
      if(this.is_answer_too_short(event)){
        this.show_qa_error("Your answer must not be a single word. Consider selecting a complete meaning span by dragging mouse over the text!")
        return false;
      }
      if(this.is_answer_duplicated(event)){
         this.show_qa_error("This answer overlaps with previous one!");
         return false;
      }
      
      this.hide_qa_error();
      return true;
    },

    is_action_unique: function(target, target_text){
      for (const key in this.staging.actions){
        let start = this.staging.actions[key].start;
        let end = this.staging.actions[key].end;
        let action_text = this.staging.passage.substring(start, end+1).toLowerCase();
        if (target != key && target_text == action_text){
          return false;
        }
      }
      return true;
    },

    // if action is unique, it shouldn't occur in both quesiton and answer
    // otherwise, it's okay --> this is not perfect check, but there seems to no better and simpler way
    answer_overlaps_question: function(answer){
      for (const key in this.staging.actions){
        let start = this.staging.actions[key].start;
        let end = this.staging.actions[key].end;
        let action_text = this.staging.passage.substring(start, end+1).toLowerCase();
        if (answer.start <= start
        &&  end <= answer.end 
        && this.is_action_unique(key, action_text)
        && this.staging.current_question.text.toLowerCase().includes(action_text)){
          return true;
        }
      }
      return false;
    },

    is_answer_too_long: function(answer){
      let start = answer.start;
      let end = answer.end;
      const answer_text = this.staging.passage.substring(start, end+1).split(" ");
      if (answer_text.length > 12){
        return true
      }
      return false;
    },

    is_answer_too_short: function(answer){
      let start = answer.start;
      let end = answer.end;
      const answer_text = this.staging.passage.substring(start, end+1).split(" ");
      if (answer_text.length === 1){
        return true
      }
      return false;
    },

    add_action: function(){
      this.trim_start_end_to_nearest_space();
      let start = this.current.selection.start;
      let end = this.current.selection.end;
      //const action = {start, end, key: action_id};
      //Vue.set(this.staging.action, action_key, action);
      // Highlight the spans.

      const action = {start, end};

      if (!this.can_add_action(action)){
          return false;
      }

      for(let i = start; i <= end; i++){
        Vue.set(this.current.selected_char_indices_for_action, i, true);
      }

      const _position = this.staging.current_action._position === null ? this.get_new_action_order_counter() : this.staging.current_action._position;
      
      let action_id = this.staging.current_action.action_id;

      if (action_id == null) {
        action_id = this.get_new_action_id();
      }

      Vue.set(this.staging.actions, action_id, {
            action_id: action_id,
            is_answered: true,
            start: start,
            end: end,
            text: this.staging.passage.substring(start, end+1),
            //span: this.staging.current_action.span,
            is_selecting: true,
            _position: _position
          });
      if (_position != this.staging.current_action._position){
        this.current.action_created = this.current.action_created + 1;
      }

      this.reset_current_action();
      this.reset_current_selection();
      //this.reset_highlight_map();
      //for (let i = start; i < end+1; i++) {
      //  Vue.set(this.current.selected_char_indices, i, true)
      //}
      //this.add_default_questions_to_passage();

    },

    reset_current_selection: function(){
      this.current.selection.start = -1;
      this.current.selection.end = -1;
      this.current.selection.current = -1;
      this.current.selection.state = "none";
    },

    reset_current_action: function(){
      this.staging.current_action.text = "";
      //this.staging.current_action.span = "";
      this.staging.current_action._position = null;
      this.staging.current_action.action_id = null;
    },

    add_answer: function(){
      this.trim_start_end_to_nearest_space();

      let start = this.current.selection.start;
      let end = this.current.selection.end;
      let event_key = start + "_" + end;

      const event = {start, end, key: event_key};
      if (!this.can_add_answer(event)){
        return false;
      }

      if(this.can_add_answer(event)){
        let start = this.current.selection.start;
        let end = this.current.selection.end;
        let event_key = start + "_" + end;
        const event = {start, end, key: event_key};
        Vue.set(this.staging.current_question.answers, event_key, event);
        // Highlight the spans.
        for(let i = start; i <= end; i++){
          Vue.set(this.current.selected_char_indices_for_answers, i, true);
        }
      }else{
        console.log("Cannot add answer.");
      }
      this.reset_current_selection();
    },

    delete_answer: function(event){
      this.$delete(this.staging.current_question.answers, event.key);
      for(let i = event.start; i <= event.end; i++){
        Vue.set(this.current.selected_char_indices_for_answers, i, false);
      }
    },

    is_selected_answer_highlight: function(idx){
      return this.current.selected_char_indices_for_answers[idx] === true;
    },

    is_selected_action_highlight: function(idx){
      return this.current.selected_char_indices_for_action[idx] === true;
    },

    highlight_selected_answer: function(start, end){
      for(let i = start; i <= end; i++){
        Vue.set(this.current.selected_char_indices_for_answers, i, true);
      }
    },

    /**
     */

    question_contains_event: function(){
      let question = this.staging.current_question.text.toLowerCase();
      for (const key in this.staging.actions){
        const action = this.staging.actions[key];
        if (question.includes(action.text)){
          return true
        }
      }
      return false
    },

    is_question_suspicious: function(){
      let trimmedQuestion = this.staging.current_question.text.toLowerCase();
      for (const key in this.staging.actions){
        const action = this.staging.actions[key];
        if (trimmedQuestion.includes(action.text.toLowerCase())){
          return false
        }
      }

      // must not include the following words
      for (let id in bad_question_keywords){
        const keyword = bad_question_keywords[id];
        if (trimmedQuestion.includes(keyword)){
          return true;
        }
      }

      // must not be one of the default questions
      for (let id in default_questions){
        const keyword = default_questions[id];
        if (trimmedQuestion.includes(keyword)){
          return true;
        }
      }

      // must ends with ?
      // if(!trimmedQuestion.endsWith('?'))
      //   return true;

      // must include one or more of the following words
      for (let id in question_keywords){
        const keyword = question_keywords[id];
        if (trimmedQuestion.includes(keyword)){
          return false;
        }
      }

      return true;

    },

    on_question_text_change: function(){
      if(this.is_question_suspicious()){
       this.show_qa_error("This question POSSIBLY doesn't include a highlighted event. You are allowed to use a different form of the selected action word (e.g. teach v.s. taught) or use an imaginary but concrete action word for [Sub-event] question. You can still add this question if you are sure.");
      }else{
        this.hide_qa_error()
      }
    },

    /**
    on_answer_text_change: function(){
      let start = this.current.selection.start;
      let end = this.current.selection.end;
      let event_key = start + "_" + end;
      const event = {start, end, key: event_key};
      console.log(event);
      if(this.is_answer_too_short(event)){
       this.show_qa_error("Single word is usually not a good answer. Consider selecting a complete meaning span by dragging your mouse over the text. You can still add it if you are sure.");
      }else{
        this.hide_qa_error()
      }
    },
    */
    /**
     *
     * Save current question to staging area. This should update the question cards.
     *
     */

    current_question_is_duplicated: function(){
      for(const key in this.staging.questions){
        if (key === this.staging.current_question.question_id){
          // We are editing the existing question, we don't have to check it with the existing one.
          continue;
        }
        const question = this.staging.questions[key];
        if (this.staging.current_question.text === question.text){
          return true;
        }
      }
      return false;
    },

    is_showing_qa_panel: function(question){
      return question.show_qa
    },

    can_add_question: function(){
      if (this.staging.current_question.text.length === 0){
        this.show_qa_error("This question is empty");
        return false;
      }

      if(this.current_question_is_duplicated()){
        this.show_qa_error("This question is the same as an existing one!");
        return false;
      }

      /**
       * Check for duplicated questions.
       */
      
      if (!this.staging.current_question.text.endsWith("?")){
          this.show_qa_error('You may forget to put "?" at the end of the question.');
          return false;
      }

      if (this.staging.current_question.type === "Sub-event"){
        if (this.staging.current_question.include_event != "yes"){
          this.show_qa_error(this.staging.current_question.type + ' question must contain a complex and concrete event!');
          return false
        }
      }
      //else{
      //  if (!this.question_contains_event()){
      //    this.show_qa_error(this.staging.current_question.type + ' question needs to include a highlighted event!');
      //    return false
      //  }
      //}

      if (Object.keys(this.staging.current_question.answers).length == 0){
        this.show_qa_error('You need to select an answer and click "Add Answer"!');
        return false
      }

      if (this.staging.current_question.type == ''){
        this.show_qa_error('You need to select a quesiton type!');
        return false
      }

      this.hide_qa_error();
      return true;
    },

    get_new_question_id: function(){
      const ret = this.current.question_id_counter;
      this.current.question_id_counter = this.current.question_id_counter + 1;
      return this.staging.passage_id + "-question-" + ret;
    },

    get_new_action_id: function(){
      const ret = this.current.action_id_counter;
      this.current.action_id_counter = this.current.action_id_counter + 1;
      return this.staging.passage_id + "-action-" + ret;
    },

    add_or_save_question: function(){
      if(this.can_add_question()){
          let question_id = this.staging.current_question.question_id;
          let is_new_question = false;

          if (question_id === null){
            question_id = this.get_new_question_id();
            is_new_question = true;
          }

          const _position = this.staging.current_question._position === null ? this.get_new_question_order_counter() : this.staging.current_question._position;

          if (this.staging.current_question.is_default_question && !this.staging.current_question.is_answered){
            this.current.default_question_answered_count = this.current.default_question_answered_count + 1;
          }

          Vue.set(this.staging.questions, question_id, {
            question_id: question_id,
            is_default_question: this.staging.current_question.is_default_question,
            is_answered: true,
            show_qa: true,
            answers: _.cloneDeep(this.staging.current_question.answers),
            text: this.staging.current_question.text,
            type: this.staging.current_question.type,
            include_event: this.staging.current_question.include_event,
            question_is_derived_from: this.staging.current_question.question_is_derived_from,
            _position: _position
          });

          if (is_new_question){
            this.current.question_created = this.current.question_created + 1;
            if(this.staging.current_question.question_is_derived_from !== null){
              this.current.question_modified += 1;
            }
          }
          //this.staging.showing_qa_work_area = this.all_event_question_answered();
        // Now we reset the working questions.
        this.staging.current_question.text = "";
        this.staging.current_question.type = "";
        this.staging.current_question.include_event = "";
        this.staging.current_question.is_default_question = false;
        this.staging.current_question._position = null;
        this.staging.current_question.question_id = null;
        this.staging.current_question.question_is_derived_from = null;
        this.staging.current_question.answers = {};
        this.clear_current_answer_highlight();

      }else{
        console.log("Cannot add question.");
      }
    },

    clear_current_answer_highlight: function(){
        for(let i = 0; i <= this.staging.passage.length; i++){
          Vue.set(this.current.selected_char_indices_for_answers, i, false);
        }
    },

    clear_current_action_highlight: function(action){ 
      for(let i = action.start; i <= action.end; i++){
        Vue.set(this.current.selected_char_indices_for_action, i, false);
      }
    },

    /**
     *
     * Handlers for buttons on question cards.
     *
     */
    delete_question: function(question){
      const question_id = question.question_id;

      this.$delete(this.staging.questions, question_id);
      this.current.question_created = this.current.question_created - 1;
      //if(question.question_is_derived_from !== null){
      //  this.current.question_modified -= 1;
      //}
    },

    delete_action: function(action){
      const action_id = action.action_id;

      this.$delete(this.staging.actions, action_id);
      this.current.action_created = this.current.action_created - 1;
      for(let i = action.start; i <= action.end; i++){
        Vue.set(this.current.selected_char_indices_for_action, i, false);
      }

    },

    derive_question: function(question){
      this.clear_current_answer_highlight();

      //const question_id = question.question_id;

      this.staging.current_question.question_id = null;
      this.staging.current_question.text = question.text;
      this.staging.current_question.is_default_question = question.is_default_question;
      //this.staging.current_question.question_is_derived_from = question_id;
      this.staging.current_question.answers = {};
      this.staging.current_question._position = null;
      this.staging.current_question.is_answered = question.is_answered;

      Vue.nextTick(function(){
        document.getElementById("question-input").focus();
      });
    },

    edit_question: function(question){
      this.clear_current_answer_highlight();

      const question_id = question.question_id;

      this.staging.current_question.question_id = question_id;
      this.staging.current_question.text = question.text;
      this.staging.current_question.is_default_question = question.is_default_question;
      //this.staging.current_question.question_is_derived_from = question.question_is_derived_from;
      this.staging.current_question.answers = _.cloneDeep(question.answers);
      this.staging.current_question._position = question._position;
      this.staging.current_question.is_answered = question.is_answered;

      for (const key in question.answers){
        const event = question.answers[key];
        this.highlight_selected_answer(event.start, event.end);
      }

      Vue.nextTick(function(){
        document.getElementById("question-input").focus();
      });
    },

    edit_action: function(action){
      this.clear_current_action_highlight(action);
      this.reset_current_action();
      this.staging.current_action.action_id = action.action_id;
      this.staging.current_action.start = action.start;
      this.staging.current_action.end = action.end;
    },

    is_selecting_event(action){
      return action.is_selecting
    },

    is_editing: function(question){
      return this.staging.current_question.question_id === question.question_id;
    },

    is_editing_action: function(action){
      return this.staging.current_action.action_id === action.action_id;
    },

    pin_to_top: function(question){
      const current_pos = question._position;

      let poss = _.map(this.staging.questions, (q) => {return q._position}).sort().reverse();
      let current_top_question = poss[0];


      let pos_transfer_map = {};

      for (let i = 0; i < poss.length; i++) {
        const pos = poss[i];
        if (pos === current_pos){
          pos_transfer_map[pos] = current_top_question;
          break;
        }
        // Since i can never by the last index, we can safely access i-1;
        const new_pos = poss[i+1];
        pos_transfer_map[pos] = new_pos;
      }

      for (const qid in this.staging.questions) {
        const q2 = this.staging.questions[qid];
        if(q2._position in pos_transfer_map){
          q2._position = pos_transfer_map[q2._position];
        }
      }


    },

    move_up: function(question){
      // const current_pos = question._position;
      // let current_top_question = _.maxBy(this.staging.questions, function(q){return q._position});
      // let poss = _.map(this.staging.questions, (q) => {return q._position}).sort();

      const current_pos = question._position;
      let next_big_pos = null;
      let next_big_question = null;

      for (const qid in this.staging.questions){
        const q2 = this.staging.questions[qid];
        const p = q2._position;
        if (p > current_pos){
          if (next_big_pos === null || p < next_big_pos){
            next_big_pos = p;
            next_big_question = q2;
          }
        }
      }

      if (next_big_pos !== null){
        question._position = next_big_pos;
        next_big_question._position = current_pos;
      }


    },

    move_down: function(question){
      const current_pos = question._position;
      let next_small_pos = null;
      let next_small_question = null;

      for (const qid in this.staging.questions){
        const q2 = this.staging.questions[qid];
        const p = q2._position;
        if (p < current_pos){
          if (next_small_pos === null || p > next_small_pos){
            next_small_pos = p;
            next_small_question = q2;
          }
        }
      }

      if (next_small_pos !== null){
        question._position = next_small_pos;
        next_small_question._position = current_pos;
      }
    },

    /**
     * Functions that help question card display.
     */
    get_all_answer_surface_form: function(question){
      const answers = question.answers;
      if (Object.keys(answers).length === 0){
        return "(The answer is intentionally left empty)"
      }else{

        let answers_surface = [];

        for(const key in answers){
          const answer = answers[key];
          answers_surface.push(
                  this.staging.passage.substring(answer.start, answer.end+1)
          );
        }

        return _.join(answers_surface, ', ');
      }
    },

    get_event_span: function(action){
      return action.span;
    },
    /**
     * Submit user annotations to server.
     */

    can_submit_fast_check: function(){

      if(this.current.question_created < this.required_question_count){
        this.show_submission_error(`You have created only ${this.current.question_created} questions, which is less than the required ${this.required_question_count}. (Default questions do not count)`);
        return false;
      }

      if(this.current.default_question_answered_count < this.current.default_question_count){
        const diff = this.current.default_question_count - this.current.default_question_answered_count;
        this.show_submission_error(`You have ${diff} warm-up questions unanswered, you must answer all of them.`);
        return false;
      }

      return true;
    },

    create_submission_object: function(){
      let pass_check = true;

      let generated_events = {};
      let generated_qas = {
        feedback: this.feedback,
        mTurkAssignmentId: this.mturk_params.assignmentId,
      };

      // Do another check to make sure we have enough data to submit.
      let default_question_answered_count = 0;
      let question_count = 0;

      for (const key in this.annotations){
        const passage = this.annotations[key];

        const passage_id = passage.passage_id;
        const passage_text = passage.passage;

        const event_response = {
          answer: {
            spans: [],
            indices: [],
            //durations: [],
          },
          passageID: passage_id,
        };


        const annotated_events = passage.actions;
        const annotated_qas = passage.questions;

        for(const qkey in annotated_qas){
          const question = annotated_qas[qkey];

          if (!question.is_answered){
            pass_check = false;
          }

          if (question.is_default_question){
            if (question.is_answered){
              default_question_answered_count++;
            }
          }else{
            question_count++;
          }

          const question_annotation = {
            question: question.text,
            answer: {
              spans: [],
              indices: [],
            },
            type: question.type,
            passageID: passage_id,
            question_id: question.question_id,
            isAnswered: question.is_answered,
            is_default_question: question.is_default_question,
            //derived_from: question.question_is_derived_from,
          };

          for(const ekey in question.answers){
            const event = question.answers[ekey];
            question_annotation.answer.indices.push(`(${event.start},${event.end+1})`);
            question_annotation.answer.spans.push(passage_text.substring(event.start, event.end+1));
          }

          generated_qas[qkey] = question_annotation;
        }

        for(const ekey in annotated_events){
          const event = annotated_events[ekey];
          event_response.answer.indices.push(`(${event.start},${event.end+1})`);
          // span here is event text span
          event_response.answer.spans.push(passage_text.substring(event.start, event.end+1));
          // span below is actually event duration (time span)
          //event_response.answer.durations.push(event.span);
        }

        const event_key = key + "-eventAction";
        generated_events[event_key] = event_response;
        // question_id: passage_id + "-question-d1",
        // is_default_question: true,
        // question_is_derived_from: null,
        // is_answered: false,
        // answers: {},
        // text: "What is happening?",
      }

      if (default_question_answered_count < 12){
        console.log("default_question_answered_count : ", default_question_answered_count)
      }

      if (question_count < this.required_question_count){
        console.log("question_count : ", question_count )
      }

      if (pass_check) {
        console.log("Passed check, ready to submit now.");
        this.generated_answers = JSON.stringify(generated_qas);
        this.generated_answers_event = JSON.stringify(generated_events);
        this.submission_not_ready = false;

        this.hide_submission_error();

        Vue.nextTick(function () {
          document.getElementById('mturk-external-submit-form').submit();
        });

        console.log(this.generated_answers);
        console.log(this.generated_answers_event);
      }else{
        console.log("Check not passed.");
        this.show_submission_error(`You may have unanswered questions.`);
      }
    },

    check_before_submit: function(){
      console.log(this.annotations);
      console.log(this.feedback);

      if(this.can_submit_fast_check()){
          this.create_submission_object();
      }

    },

    focus_feedback: function(){
      document.getElementById("feedback-form").focus();
    },

    /**
     *
     * Functions for handling passage switching.
     *
     */

    previous_passage: function(){
      // const passage_id = Math.max(this.staging.passage_id-1, 0);
      const total_num_of_passages = Object.keys(this.annotations).length;
      const passage_id = (this.staging.passage_id - 1 + total_num_of_passages) % total_num_of_passages;

      if (passage_id === this.staging.passage_id){
        return;
      }

      this.save_staged_passage();
      this.stage_new_passage(passage_id);
    },

    next_passage: function(){

      // const passage_id = Math.min(this.staging.passage_id+1, Object.keys(this.annotations).length - 1);
      const passage_id = (this.staging.passage_id+1) % Object.keys(this.annotations).length;

      if (passage_id === this.staging.passage_id){
        return;
      }

      //if (!this.staging.showing_qa_panel){
      //  this.show_event_error("Click on 'Finish Event Selection' before you move on!");
      //  return;
      //}

      this.save_staged_passage();
      this.stage_new_passage(passage_id);
    },


    stage_new_passage: function(passage_id){
      this.clear_selection();
      this.reset_highlight_map();
      this.reset_current_action();
      this.staging.passage_id = passage_id;
      const annotation = this.annotations[passage_id];
      //const has_events = Object.keys(annotation.events).length > 0;

      this.staging.passage = annotation.passage;
      this.staging.questions = annotation.questions;
      this.staging.events = annotation.events;
      this.staging.showing_qa_panel = false;
      this.staging.actions = annotation.actions;
      this.finish_event_selection_text = "Finish Event Selection";
      this.current.action_created = Object.keys(this.staging.actions).length;
      this.do_highlight_all_action_selection();
      /** 
      if(has_events){
        this.staging.showing_qa_panel = true;
        this.do_highlight_all_event_selection();
      }else{
        this.staging.showing_qa_panel = false;
      }
      */
    },
    /**
     * Save whatever user has changed.
     */
    save_staged_passage: function(){
      const existing_annotation = this.annotations[this.staging.passage_id];
      existing_annotation.events = this.staging.events;
      existing_annotation.actions = this.staging.actions;
      existing_annotation.questions = this.staging.questions;
    },

    /*************************************************************************************
     *
     * Below methods are used to handling span selections.
     *
     ************************************************************************************/

    mousedown_text: function(index){
      this.current.selection.start = index;
      this.current.selection.state = "selecting";
    },

    mouseup_text: function(index){
      this.current.selection.end = index;
      this.current.selection.state = "none";
      let _start = Math.min(this.current.selection.start, this.current.selection.end);
      let _end = Math.max(this.current.selection.start, this.current.selection.end);
      this.current.selection.start = _start;
      this.current.selection.end = _end;
    },

    mouseenter_text: function(index){
      this.current.selection.current = index;
    },

    /**
     * invalidate the current selection, this happens when mouse moved out of the selection scope.
     */
    invalidate_selection: function(){
      if (this.current.selection.state !== "none"){
        this.clear_selection(false);
      }
    },
    
    turn_on_event_highlight: function(){
      if (!this.staging.showing_qa_panel){
        this.do_highlight_all_event_selection();
      }
    },

    highlight_actions: function(){
      this.do_highlight_all_event_selection();
    },
    /**
     * Should the current char be highlighted as part of the selection process?
     */
    is_in_selection_highlight: function(idx){
      if(this.current.selection.state === "selecting"){
          return (idx >= Math.min(this.current.selection.current, this.current.selection.start)) && (idx <= Math.max(this.current.selection.current, this.current.selection.start))
      }

      if(this.current.selection.state === "none"){
        return (idx >= this.current.selection.start) && (idx <= this.current.selection.end);
      }

      return false;

    },
    all_event_question_answered: function(){
      var all_answered = true;
      for (let i = 0; i < 4; i++){
        var qid = this.staging.passage_id.toString().concat('-question-d').concat(i.toString());
        if (!this.staging.questions[qid].is_answered){
          all_answered = false;
        }
      }
      return all_answered
    },
    /**
     * When double click on a char, it automatically expand to the entire word.
     */
    double_clicked_text: function(index){
      function shouldStop(char){
        return char === " " || char === "." ||
                char === "," || char === "?" ||
                char === "'" || char === '"' ||
                char === "!" || char === ";" ||
                char === ":" || char === "\n" ||
                char === "\t"
                ;
      }
      let end = this.staging.passage.length - 1;
      for (let i = index; i < this.staging.passage.length; i++){
        if(shouldStop(this.staging.passage[i])){
          end = i - 1;
          break;
        }
      }

      let start = 0;
      for (let i = index; i > 0; i--){
        if(shouldStop(this.staging.passage[i])){
          start = i + 1;
          break;
        }
      }
      this.current.selection.start = start;
      this.current.selection.end = end;
    },

    clear_selection: function(remove_question = true){
      this.current.selection.state = "none";
      this.current.selection.start = -1;
      this.current.selection.end = -1;
      this.current.selection.current = -1;

      if (remove_question) {
        this.staging.current_question._position = null;
        this.staging.current_question.answers = {};
        this.staging.current_question.is_default_question = false;
        this.staging.current_question.question_id = null;
        //this.staging.current_question.question_is_derived_from = null;
        this.staging.current_question.text = "";  
      }
      
    },

    get_new_question_order_counter: function(){
        let ret = this.question_order_counter;
        this.question_order_counter += 1;
        return ret;
    },

    get_new_action_order_counter: function(){
        let ret = this.action_order_counter;
        this.action_order_counter += 1;
        return ret;
    }

  },

  /**
   * For display formatting.
   */
  filters: {
    currency: function(value){
      return value.toFixed(2);
    }
  },

}
</script>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Opera and Firefox */
}

.passage-display-box span.highlight{
  background: yellow;
}

.passage-display-box .passage-text span{
  cursor: text
}
/*.passage-display-box span:hover{*/
  /*background: lightskyblue;*/
/*}*/

.passage-display-box span.select_highlight{
  background: lightskyblue;
}

form.hidden {
  display: none;
}

.passage-display-box span.is_selected_answer{
  color: red;
  font-style: italic;
  border-bottom: thick solid rgb(0, 0, 255);
}

.passage-display-box span.action_highlight{
  color: rgb(255, 0, 0);
  font-style: italic;
}

div.inline_div{
  display: inline;
}

.flip-list-move {
  transition: transform 1s;
}
.nav-item.active{
  /*color: red !important;*/
  border-bottom-style: solid !important;
  border-bottom: 0px red !important;
  cursor: pointer;
}

.nav-item{
  /*color: red !important;*/
  border-bottom: 2px grey !important;
  border-bottom-style: dotted !important;

  cursor: pointer;
}
.button-question-tooltip{
  width: 1.5em;
  height: 1.5em;

  font-size: small;
  color: #CCC;
  text-shadow: 1px #CCC;

  border: 1px solid #CCC;
  border-radius: 25px;
  box-shadow: 0.1em #CCC;

  display: inline-block;
}
</style>
